import React, { useState } from 'react'
import TableComponent from '../Components/TableComponent'
import baseUrl from '../config';

export default function TruPunch5000() {
  const [modifiedData, setModifiedData] = useState([]);

  const api = `${baseUrl}/listResultsCutting`
  return (
    <div>
      <TableComponent
        modifiedData={modifiedData}
        setModifiedData={setModifiedData}
        api={api}
        filterText="TRUPUNCH 5000"
      />
    </div>
  )
}
